/**
 * The build id every command carries as `clientBuild` (design §5.3).
 *
 * Replaced at build time by a Vite `define`
 * (`vite.config.ts`) with `tools/scripts/write-client-build.ts`'s printed
 * value — CORRECTED here, Task 15: an earlier version of this comment called
 * that value "a content hash over `dist/.vite/manifest.json`", which reads
 * as a claim about the manifest that SHIPS. Measured, it is not: that script
 * hashes a FIRST-PASS manifest, built before this value is known, and
 * injecting it into the second, real pass changes the injected chunk's own
 * content hash (and, transitively, every chunk that imports it by that
 * hashed filename — see that script's own doc comment for the full,
 * measured cascade). So this value is a deterministic function of the
 * source tree that changes whenever any emitted asset changes — a valid
 * release identifier — but it is not, and must not be described as, a
 * digest of the bytes actually shipped.
 */
declare const __CLIENT_BUILD__: string | undefined

export const CLIENT_BUILD: string = typeof __CLIENT_BUILD__ === 'string' ? __CLIENT_BUILD__ : 'dev'
